module.exports = __webpack_public_path__ + "static/media/redemptionImages.b7f76a70.jpg";